import { useFlag } from '@automata/utils/hooks';
import { useMemo } from 'react';

export const useGetInstrumentsState = (workcellId: string) => {
  const isUcbAgilentBiotekUseAllowed = useFlag('fe.ucb_use_agilent_biotek');

  const instrumentStates: Record<string, Record<string, boolean>> = useMemo(
    () => ({
      azProd: {
        agilent_lhc: false,
        biotek: true,
      },
      ucbProd: { agilent_biotek: isUcbAgilentBiotekUseAllowed ?? false },
    }),
    [isUcbAgilentBiotekUseAllowed]
  );

  return instrumentStates[workcellId] ?? {};
};
